module.exports = __webpack_public_path__ + "static/media/no_image.264ad03e.png";